import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export const NotFound = () => {
  return (
    <div className="min-h-screen pt-24 pb-20 flex items-center">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-sm font-medium text-muted-foreground mb-3">404 – Page Not Found</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-bold mb-4">
          This page doesn&apos;t exist.
        </h1>
        <p className="text-lg text-muted-foreground mb-8 max-w-xl mx-auto">
          The link you followed might be broken, expired, or the page may have been moved.
          Let&apos;s get you back to something useful.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90">
              Go back home
            </Button>
          </Link>
          <Link to="/contact">
            <Button
              size="lg"
              variant="outline"
              className="border-primary text-primary hover:bg-primary/5 hover:text-primary hover:border-primary"
            >
              Contact our team
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

